module.exports = __webpack_public_path__ + "static/media/lga-payments.4798bafb.jpg";